export const INTERVIEW_VIEW = /** @constant */ {
    JOIN: { value: "JOIN" },
    ROOM: { value: "ROOM" },
    SEEK: { value: "SEEK" },
};
